import {useEffect, useState} from "react";
import {projectMeetingsApi} from "../../../models/project/project-meetings-api";

// «جلسه‌های من»: the meetings a person is invited to, owns or created — shown as cards in their task list (boss's task,
// 2026-10-27; docs/tasks/30-meeting-cards.md). One request for the workspace, shared by every list that shows them,
// read again after a minute or when a meeting changes.

export const MY_MEETINGS_CHANGED = "my-meetings:changed";
const FRESH_MS = 60000;
const store = {meetings: [], today: null, loadedAt: 0, loading: null, listeners: new Set()};

const publish = () => store.listeners.forEach((listener) => listener({meetings: store.meetings, today: store.today}));

export async function loadMyMeetings(force = false) {
    if (store.loading) return store.loading;
    if (!force && Date.now() - store.loadedAt < FRESH_MS) return {meetings: store.meetings, today: store.today};
    store.loading = projectMeetingsApi.myMeetings()
        .then((data) => {
            store.meetings = data?.meetings || [];
            store.today = data?.today || null;
            store.loadedAt = Date.now();
            publish();
            return {meetings: store.meetings, today: store.today};
        })
        .catch(() => ({meetings: store.meetings, today: store.today}))
        .finally(() => { store.loading = null; });
    return store.loading;
}

export function useMyMeetings() {
    const [state, setState] = useState({meetings: store.meetings, today: store.today});
    useEffect(() => {
        store.listeners.add(setState);
        loadMyMeetings();
        const refresh = () => loadMyMeetings(true);
        window.addEventListener(MY_MEETINGS_CHANGED, refresh);
        return () => {
            store.listeners.delete(setState);
            window.removeEventListener(MY_MEETINGS_CHANGED, refresh);
        };
    }, []);
    return state;
}
